<template>
<layout-content>
  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="list"
        height="100%"
        border
        stripe
        lazy
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table no-inner-border"
        style="width: 100%"
        @row-click="onOpenEditor"
      >
        <el-table-column label="序号" width="70">
          <template v-slot="{$index}">{{$index + 1}}</template>
        </el-table-column>

        <el-table-column prop="factorId" label="因子ID" />
        <el-table-column prop="factorName" label="标准名称" />
        <el-table-column prop="alias" label="别名(上传名称)" />

<!--        <el-table-column label="操作" width="150" align="center">-->
<!--          <template v-slot="{row}">-->
<!--            <div class="table-operator-wrapper">-->
<!--            <span class="table-operator-btn delete-btn" @click.stop="onShowDeleteConfirmDialog(row)">-->
<!--              <i class="el-icon-delete" aria-hidden="true"></i>-->
<!--            </span>-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </data-wrapper>
  </template>
  <template #footer>
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :total="total"
      style="float: right;"
    >
    </el-pagination>
  </template>

  <template #editor>
    <editor
      ref="editor"
      @save="getList"
      @close="onCancelHighlightTableRow"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../../BaseListEditor'
import DataWrapper from '../../../../components/Data/DataWrapper'
import Editor from './Editor'

export default {
  name: 'SystemSettingsFactorAlias',
  routeInfo: {
    label: '因子别名管理',
    icon: 'fa fa-dot-circle-o',
    curdInfo: {
      api: 'FactorAlias',
      id: 'alias',
      name: 'name',
      editName: '别名'
    }
  },
  extends: BaseListEditor,
  components: {Editor, DataWrapper},
  data () {
    return {
      dataList: [],
      list: [],
      pageSize: 100,
      currentPage: 1,
      total: 0
    }
  },
  methods: {
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.currentChangePage(this.dataList, currentPage)
    },
    currentChangePage (list, currentPage) {
      let from = (currentPage - 1) * this.pageSize
      let to = currentPage * this.pageSize
      this.list = []

      for (; from < to; from++) {
        if (list[from]) {
          this.list.push(list[from])
        }
      }
    },
    onShowDeleteConfirmDialog (data) {
      this.$confirm(`此操作将永久删除该记录', 是否继续？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-dialog-confirm-btn',
        cancelButtonClass: 'confirm-dialog-cancel-btn',
        type: 'warning'
      }).then(() => {
        this.onDelete(data)
      }).catch(() => {})
    },
    onDelete (data) {
      this.$api.FactorAlias.delAlias(data.alias, data.factorId).then(this.deleteSuccess).catch(this.deleteFailed)
    },
    getList () {
      this.changeLoadStatus(true)

      this.$api.FactorAlias.getList().then(backData => {
        if (backData.length === 0) {
          this.dataList = []

          return false
        }

        let {factorMap} = this
        let data = backData.map(item => {
          item.factorName = factorMap[Number(item.factorId)] ? factorMap[Number(item.factorId)].name : '--'

          return item
        })
        this.dataList = Object.freeze(data)
        this.total = backData.length
        if (this.total > this.pageSize) {
          for (let index = 0; index < this.pageSize; index++) {
            this.list.push(data[index])
          }
        } else {
          this.list = data
        }

        this.handleCurrentChange(1)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  },
  watch: {
    factors: {
      immediate: true,
      handler (factors) {
        if (factors.length > 0) {
          this.getList()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/07Factor-Alias/index.vue